import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import Moment from 'moment';
import {
    Input,
    Dropdown,
    Icon,
    Label,
    Grid,
    Button,
    Text,
    Header,
} from 'semantic-ui-react'
import _ from 'underscore';

class ClaimFilterRecords extends Component {
    constructor(props) {
        super(props);
        const { fromDate, toDate, filterByClaimant, filterByCompany } = this.props.claimFilterOptions;
        this.state = {
            fromDate: Moment(fromDate),
            toDate: Moment(toDate),
            filterByCompany : filterByCompany ? filterByCompany : this.props.user.companies[0].companyId,
            filterByClaimant,
            filterCompanyHeaderText: this.props.user.companies[0].companyName,
            filterClaimantHeaderText: 'All Claimants'
        }
        this.handleFilterClaimantChange = this.handleFilterClaimantChange.bind(this);
        this.handleFilterCompanyChange = this.handleFilterCompanyChange.bind(this);
    }

    componentDidMount() {
        const {filterByClaimant, filterByCompany} = this.props.claimFilterOptions;
        if (filterByClaimant) {
            let filterClaimantHeaderText = '';
            const {records} = this.props.user;
            for (let i = 0; i < records.length; i++) {
                console.log('here', records[i]);
                if (records[i].uuid === filterByClaimant) {
                    filterClaimantHeaderText = records[i].name;
                }
            }
            this.setState({filterClaimantHeaderText})
        }
        if (filterByCompany) {
            let filterCompanyHeaderText = this.props.user.companies[0].companyName;
            const {companies} = this.props.user;
            for (let i = 0; i < companies.length; i++) {
                console.log('here', companies[i]);
                if (companies[i].companyId === filterByCompany) {
                    filterCompanyHeaderText = companies[i].companyName;
                }
            }
            this.setState({filterCompanyHeaderText})
        }
    }
    handleFromDateChange(momentValue,e) {
        this.setState({fromDate: momentValue});
    }
    handleToDateChange(momentValue,e) {
        this.setState({toDate: momentValue});
    }
    handleFilterClaimantChange(e, data) {
        // console.log(data);
        this.setState({filterByClaimant: data.value, filterClaimantHeaderText: data.text});
    }
    handleFilterCompanyChange(e, data) {
        // console.log(data);
        this.setState({filterByCompany: data.value, filterCompanyHeaderText: data.text, filterByClaimant: null, filterClaimantHeaderText: 'All Claimants' });
    }
    handleApplyFilter() {
        console.log('clicked', this.state);
        const { fromDate, toDate, filterByClaimant, filterByCompany } = this.state;
        this.props.updateClaimFilterOptions({fromDate, toDate, filterByClaimant, filterByCompany});
    }
    render() {
        const { fromDate, toDate, filterByClaimant, filterByCompany, filterClaimantHeaderText, filterCompanyHeaderText} = this.state;
        const employeeCompanies = this.props.user.companies.filter( company => company.memberType.toUpperCase() == "E");

        const filterCompanyOptions = _.map(employeeCompanies, (company) => {
            const {companyId, companyName} = company;
            return (
                <Dropdown.Item
                    key={companyId}
                    text={companyName}
                    value={companyId}
                    onClick={this.handleFilterCompanyChange}
                    active={(companyId === filterByCompany)}
                />
            )
        });
        // const filterClaimantOptions = _.map(this.props.user.records, (record) => {
        const selectedCompany = this.props.user.companies.filter(company => company.companyId == filterByCompany)
        
        const filterClaimantOptions = _.map(selectedCompany[0].records, (record) => {
            const {uuid, name} = record;
            return (
                <Dropdown.Item
                    key={uuid}
                    text={name}
                    value={uuid}
                    onClick={this.handleFilterClaimantChange}
                    active={(uuid === filterByClaimant)}
                />
            )
        });
        return (
            <Grid columns={this.props.user.companies.length <= 1 ? 5 : 6}>
                <Grid.Column verticalAlign='middle' >
                    <Header textAlign='right' size='small'>Visit/Admission Date</Header>
                </Grid.Column>
                <Grid.Column>
                    <DatePicker
                        dateFormat="DD MMM YYYY"
                        customInput={<Input style={{width:120}} labelPosition="left" label={<Label> From</Label>} />}
                        selected={fromDate}
                        onChange={this.handleFromDateChange.bind(this)}
                        maxDate={Moment()}
                    />
                </Grid.Column>
                <Grid.Column>
                    <DatePicker
                        dateFormat="DD MMM YYYY"
                        customInput={<Input style={{width:120}} labelPosition="left" label={<Label> To</Label>} />}
                        selected={toDate}
                        onChange={this.handleToDateChange.bind(this)}
                        minDate={fromDate}
                        maxDate={Moment()}
                    />
                </Grid.Column>
                { this.props.user.companies.length > 1 &&
                <Grid.Column>
                    <Dropdown text={filterCompanyHeaderText} icon='building' floating labeled button className='icon'>
                        <Dropdown.Menu>
                            <Dropdown.Header icon='tags' content='Filter by company' />
                            {/* <Dropdown.Item
                                key='default'
                                text="All Companies"
                                value={null}
                                onClick={this.handleFilterCompanyChange}
                                active={!filterByCompany}
                            /> */}
                            {filterCompanyOptions}
                        </Dropdown.Menu>
                    </Dropdown>
                </Grid.Column>}
                <Grid.Column>
                    <Dropdown text={filterClaimantHeaderText} icon='users' floating labeled button className='icon'>
                        <Dropdown.Menu>
                            <Dropdown.Header icon='tags' content='Filter by claimant' />
                            <Dropdown.Item
                                key='default'
                                text="All Claimants"
                                value={null}
                                onClick={this.handleFilterClaimantChange}
                                active={!filterByClaimant}
                            />
                            {filterClaimantOptions}
                        </Dropdown.Menu>
                    </Dropdown>
                </Grid.Column>
                <Grid.Column>
                    <Button
                        style={{width:150}}
                        secondary
                        fluid
                        onClick={this.handleApplyFilter.bind(this)}>
                        Apply Filter
                    </Button>
                </Grid.Column>
            </Grid>
        );
    }
}

export default ClaimFilterRecords;
